<section>
  <div class="row pt-4" style="margin: 0">
    <div class="filter" style="margin-left: 5%">
      <mat-form-field class="w-100">
        <input
          matInput
          type="text"
          [(ngModel)]="nameFilter"
          [placeholder]="'signature_config.singature_filter' | translate"
          maxlength="200"
          autocomplete="off"
          (keydown.enter)="$event.preventDefault()"
          (input)="filterTable()"
        />
        <button
          mat-button
          type="button"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          *ngIf="nameFilter"
          (click)="clearData()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-12 table_box">
      <mat-table [dataSource]="dataSource">
        <!-- số thứ tự Column -->
        <ng-container matColumnDef="stt">
          <mat-header-cell
            *matHeaderCellDef
            class="mat-cell-non-boder-right-bottom"
            >{{ "headertable.stt" | translate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element; let i = index"
            class="mat-cell-non-boder-right-bottom"
          >
            {{ i + 1 }}
          </mat-cell>
        </ng-container>

        <!-- Tên chân ký Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell
            *matHeaderCellDef
            class="mat-cell-non-boder-right-bottom"
            >{{ "headertable.signature_name" | translate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element; let i = index"
            class="mat-cell-non-boder-right-bottom cellForSignature"
            [matTooltip]="displayTooltip(element?.name, i, 'name')"
          >
            <span class="fix-width fw-100 name">{{ element?.name }}</span>
          </mat-cell>
        </ng-container>

        <!-- Đối tượng Column -->
        <ng-container matColumnDef="subject">
          <mat-header-cell
            *matHeaderCellDef
            class="mat-cell-non-boder-right-bottom"
            >{{ "headertable.subject" | translate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element; let i = index"
            class="mat-cell-non-boder-right-bottom"
            [matTooltip]="displayTooltip(element?.object, i, 'subject')"
          >
            <span
                class="fix-width fw-100 subject"
                *ngIf="element.object === 'ENTERPRISEAPPROVER'"
            >Người dùng phê duyệt bên lập</span
            >
            <span
              class="fix-width fw-100 subject"
              *ngIf="element.object === 'ENTERPRISE'"
              [matTooltip]="enterpriseSign ? ('Ký duyệt bên lập - '+ enterpriseSign.name) : ''"
              >Người dùng ký duyệt bên lập<span *ngIf="enterpriseSign"> - {{enterpriseSign.name}}</span></span
            >
            <span
              class="fix-width fw-100 subjectField"
              *ngIf="element.object === 'CUSTOMER'"
              >Khách hàng</span
            >
            <span
              class="fix-width fw-100 subjectField"
              *ngIf="element.object === 'CUSTOMERAPPROVER'"
            >Người dùng phê duyệt bên khách hàng</span
            >
          </mat-cell>
        </ng-container>

        <!-- Trang chứa chân ký Column -->
        <ng-container matColumnDef="page">
          <mat-header-cell
            *matHeaderCellDef
            class="mat-cell-non-boder-right-bottom"
            >{{ "headertable.page_signature" | translate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            class="mat-cell-non-boder-right-bottom"
          >
            <span *ngFor="let item of element?.pageDatas;let i = index"
              ><span>
                {{ item
                }}<span
                  *ngIf="
                    element?.pageDatas.length > 1 &&
                    item !== element?.pageDatas[element?.pageDatas.length - 1]
                  "
                  >,
                </span></span
              ></span
            >
          </mat-cell>
        </ng-container>

        <!-- Tác động Column -->
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef class="text-center">
            {{ "headertable.action_header" | translate }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element; let i = index"
            class="text-center"
          >
            <button
              mat-icon-button
              type="button"
              color="primary"
              (click)="onOpenDialogSignatureConfig(element)"
            >
              <mat-icon
                matTooltip="{{ 'signature_config.config_tooltip' | translate }}"
                >settings</mat-icon
              >
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="element-row"
        >
        </mat-row>
      </mat-table>
      <div style="margin-top: 10px" *ngIf="dataSource.length">
        {{"headertable.note_signature_start" | translate}}"<button
          mat-icon-button
          type="button"
      >
        <mat-icon style="color:#07736C">settings</mat-icon>
      </button>"{{"headertable.note_signature_end" | translate}}
      </div>
      <div class="no-data" *ngIf="!dataSource.length">
        {{ "form.no_record" | translate }}
      </div>
    </div>
  </div>
</section>
